import { Component, input, Input, OnChanges, Pipe, PipeTransform, SimpleChanges } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { NgbAccordionModule, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { SvgIconComponent } from 'angular-svg-icon';
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SkeletonModule } from 'primeng/skeleton';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-module-list',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    TranslateModule,
    NgbAccordionModule,
    NgbProgressbarModule,
    SvgIconComponent,
    DropdownModule,
    SkeletonModule
  ],
  templateUrl: './module-list.component.html',
  styleUrl: './module-list.component.scss'
})
export class ModuleListComponent implements OnChanges {

  @Input() course: any;
  @Input() teachers: any;
  @Input() loading: boolean = true;

  defaultAvatar = environment.defaultAvatar;
  profileImageUrl = environment.defaultAvatar;
  percentage: number = 51;
  teacherUniversity: any;


  AssignmentList: any = [
    // {
    //   title:'Assignment 01',
    //   subTitle:'Programming Javascript 2 for Data Science tcfdat - VS0101',
    //   date:'July 24 at 8 AM',
    // },
    // {
    //   title:'Assignment 02',
    //   subTitle:'Programming Javascript 2 for Data Science tcfdat - VS0101',
    //   date:'July 24 at 8 AM',
    // },
    // {
    //   title:'Assignment 03',
    //   subTitle:'Programming Javascript 2 for Data Science tcfdat - VS0101',
    //   date:'July 24 at 8 AM',
    // },
  ];


  ngOnChanges(changes: SimpleChanges): void {
    // console.log(this.course);
    // console.log(this.teachers);

    this.teachers.forEach((teacher: any) => {
      teacher.university = teacher?.resume?.educationalRecords?.length ? teacher?.resume?.educationalRecords[0].universityRefTitle : '';

    });

    this.course?.chapters.forEach((chapter: any) => {
      chapter.teachers = this.teachers.filter((x: any) => chapter.lessons.map((x: any) => x.teacherId).indexOf(x.id) > -1);
      chapter.percentage = chapter.lessons.length ? chapter.lessons.filter((x: any) => x.isViewed).length / chapter.lessons.length * 100 : 0;
    })
  }


}